module.exports = __webpack_public_path__ + "static/media/canon.c539a03b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/canon.png
// module id = 47
// module chunks = 0